import { useCallback } from 'react';
import config from '../../src/client/config';
import appendUTMParams from '../utils/utmParams';

const { addABusinessRoot } = config;

const useOnAddABusinessClick = () => {
  const onAddABusinessClick = useCallback(() => {
    window.open(appendUTMParams(addABusinessRoot), '_blank');
  }, []);

  return {
    onAddABusinessClick: () => onAddABusinessClick(),
  };
};

export default useOnAddABusinessClick;
